let startTime = 0;
let timePassedFromEpisodeStart = 0;

export const requestAnimFrame = (function customRequestAnimFrame(window) {
  const suffix = 'equestAnimationFrame';
  const rAF = ['r', 'webkitR', 'mozR', 'msR', 'oR'].filter(
    (val) => val + suffix in window,
  )[0] + suffix;

  return (
    window[rAF]
    || function fallbackRequestAnimFrame(callback) {
      window.setTimeout(() => {
        callback(+new Date());
      }, 1000 / 60);
    }
  );
}(window));

export function setTimePassedFromEpisodeStart({ episodeStartTime, currentTime, delay }) {
  const result = new Date(currentTime).getTime() - new Date(episodeStartTime).getTime() + delay;
  timePassedFromEpisodeStart = (result > 0 ? result : 0) - startTime;
}

export function setStartTime(value) {
  startTime = value;
}

export function getStartTime() {
  return startTime;
}

export function getElapsed(timestamp) {
  const now = timestamp || getNow();
  return now + timePassedFromEpisodeStart;
}

export function getElapsedSeconds(timestamp) {
  return getElapsed(timestamp) / 1000;
}

export function isPlayerAhead(playerTime) {
  return playerTime > getElapsedSeconds();
}

function getNow() {
  return performance.now();
}
